export const linkIntelligenceQrArticle = {
  title: 'Link Intelligence Suite: QR Codes & My Links',
  slug: 'link-intelligence-qr',
  content: `Link Intelligence Suite: QR Codes & My Links

Use the QR Code and My Links tabs to manage assets.

1) QR Code tab
- Set a target URL and optional custom short code.
- Customize size, margin, and colors before generating.

2) My Links tab
- Browse existing short links.
- Open analytics or delete links from the list.
`,
};
